import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  companyResponsiblesLength: 0,
  companyResponsibles: [],
  companyResponsible: {},
  companyResponsibleError: "",
  formError: "",
  companyResponsiblesSelect: []
};

export default function companyResponsibleReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_COMPANY_RESPONSIBLE:
      return { ...state, loading: action.payload };

    case actions.LOADING_COMPANY_RESPONSIBLE_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_COMPANY_RESPONSIBLE:
      return { ...state, saveLoading: action.payload };

    case actions.GET_COMPANY_RESPONSIBLE:
      return {
        ...state,
        companyResponsibles: action.payload.companyResponsibles,
        companyResponsiblesLength: action.payload.companyResponsiblesLength,
      };

    case actions.GET_COMPANY_RESPONSIBLE_BY_ID:
      return { ...state, companyResponsible: action.payload };

    case actions.GET_COMPANY_RESPONSIBLE_SELECTS:
      return { ...state, companyResponsiblesSelect: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.COMPANY_RESPONSIBLE_FAIL:
      return { ...state, companyResponsibleError: action.payload };

    default:
      return state;
  }
}
